declare var process: any;

import * as Cookies from 'js-cookie';

const APP_COOKIE = process.env.APP_COOKIE || 'my-auth-cookie';
const API_URL = process.env.API_URL || 'http://localhost:9000';

class API {
  /**
   * Get the API URL
   * @return {String}
   */
  static getURL = () => API_URL;

  /**
   * Make an API request
   * @param {String} path
   * @param {String} method
   * @param {Object|Boolean} body
   * @return {Promise}
   */
  static request = (path, method = 'GET', body: any = false) => {
    const localData = Cookies.getJSON(APP_COOKIE);
    const options: any = {
      method,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    };
    console.log(API_URL, 'API_URL in redux')

    if (localData) {
      options.headers.token = localData.token;
      options.headers.userId = localData.user.id;
      if (localData.user.accounts) {
        options.headers.accountId = localData.user.accounts.filter(
          (account) => account.user_account.is_default,
        )[0].id;
      } else {
        // If they are coming from an older version without accounts
        // they will need to be logged out to retrieve this data
        Cookies.remove(APP_COOKIE);
        window.location.reload();
      }
    }

    if (body) {
      options.body = Object.keys(body)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(body[key])}`,
        )
        .join('&');
    }

    try {
      return fetch(`${API.getURL()}${path}`, options);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  public static get authParams(): string {
    const localData = Cookies.getJSON(APP_COOKIE);
    const accountId = localData.user.accounts.filter(
      (account) => account.user_account.is_default,
    )[0].id;
    return `token=${localData.token}&userId=${
      localData.user.id
    }&accountId=${accountId}`;
  }
}

export default API;
